window.addEventListener('DOMContentLoaded', () => {
    // 商品ページ
    if(location.href.split('/').includes('products')){
        // 商品情報のJSONを取得
        const path = location.pathname.split('/');
        const defaultHandle = path[path.length - 1];

        IC.getRequest(`/products/${defaultHandle}.js`).then(instances => {
            IC.putStyleSheets();

            // 商品情報の取得
            const param = {'商品名': instances.title};
            if(instances.options.length){
                for(const i in instances.options){
                    if(instances.options[i].name === 'Title') break;
                    const radios = document.querySelectorAll(`[name="option${instances.options[i].position}"]`);
                    let val = ""
                    for(n in radios) {
                      if(radios[n].checked) {
                        val = radios[n].value;
                        break;
                      }
                    }
                    param[instances.options[i].name] = val || '';
                }
            }

            const anker = document.createElement('a');
            anker.target = '_blank';
            anker.classList.add('item-contact');
            anker.classList.add('button');
            anker.classList.add('w-full');
            anker.innerHTML = '商品を問い合わせる';
            anker.href = '/pages/contact' + IC.requestParam(param);

            // カートに入れるボタンの次に設置
            document.querySelector('.buy-buttons .button').parentNode.insertBefore(
                anker, document.querySelector('.buy-buttons .button').nextElementSibling
            );

            document.querySelector('[action="/cart/add"]').addEventListener('change', () => {
                if(instances.options.length){
                    for(const i in instances.options){
                        if(instances.options[i].name === 'Title') break;
                        const select = document.querySelectorAll(`form[action="/cart/add"] [name="option1"], form[action="/cart/add"] [name="quantity"]`)[i];
                        console.log(select);
                        param[instances.options[i].name] = select.querySelector('option:checked').value || '';
                    }
                    document.querySelector('.item-contact').href = '/pages/contact' + IC.requestParam(param);
                }
            })
        });
    }

    // お問い合わせページ
    if(location.pathname.split('/').includes('contact') && location.search.length){
        const array = decodeURIComponent(atob(location.search.substring(1))).split('&');
        let context = `▼ 商品についてのお問い合わせ\n`;
        for(const param of array){
            const str = param.split('=');
            context += `${str[0]} : ${str[1]}\n`; 
        }
        context += `URL : ${document.referrer}\n`;
        const contact_type = document.querySelector('[value="掲載商品について"]');
        if(contact_type != null) {
          contact_type.selected = true;
        }
        document.querySelector('textarea').value = `${context}\n`;
    }
})

const IC = {
    getRequest: async src => {
        return await (await fetch(src)).json()
    },
    putStyleSheets: () => {
        const style = document.createElement('style');
        const defaultStyle = `.item-contact{
            --button-background: 131 131 131;--button-outline-color: 131 131 131;
        }`;
        style.innerHTML = defaultStyle;
        document.head.appendChild(style);
    },
    requestParam: obj => {
        return '?' + btoa(Object.entries(obj).map(e => encodeURIComponent(`${e[0]}=${e[1]}`)).join('&'))
    },
}